/**
 * Lista modelos LLM disponiveis para o usuario logado (M8 / chat
 * direto). Backend faz interseccao dos ``TeamAllowedModel`` dos times
 * em que o user eh membro.
 */
import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { MyAllowedModel } from "@/api/types";

const KEY = ["me", "allowed-models"] as const;

export function useAllowedModels() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.GET<MyAllowedModel[]>("/me/allowed-models"),
    staleTime: 60_000,
  });
}
